import React, { FC } from "react";
import { useAuth } from "Components/Auth/AuthProvider";
import AuthSignInView from "Components/Auth/AuthSignInView";
import LoadingIndicator from "Components/Layout/LoadingIndicator";
import ErrorView from "Components/Layout/ErrorView";
import { useVersionInterval } from "Providers/VersionProvider";
import AppView from "Components/Layout/AppView";

const AuthView: FC = () => {
  useVersionInterval();
  const auth = useAuth();

  if (auth.error) {
    return <ErrorView error={auth.error} />;
  } else if (auth.isLoading) {
    return <LoadingIndicator />;
  } else if (auth.viewer) {
    return <AppView />;
  } else {
    return <AuthSignInView />;
  }
};

export default AuthView;
